module.exports = __webpack_public_path__ + "img/store-admin.f42b590e.svg";